import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { Waiting } from '../../../components/Waiting/Waiting';
import { HomepageSettings } from './HomepageSettings';
import { VisualSettings } from './VisualSettings';

export const GeneralFrontendSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.FRONTEND)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleSubmit = (keys: string[]) => {
    setLoading(true);
    upsertSettings(settings.filter((s) => keys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Grid container spacing={2}>
      <Waiting open={loading} />
      <Grid size={{ xs: 12, lg: 6 }}>
        <VisualSettings
          settings={settings}
          onChange={setSettings}
          onSave={handleSubmit}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <HomepageSettings
          settings={settings}
          onChange={setSettings}
          onSave={handleSubmit}
        />
      </Grid>
    </Grid>
  );
};
